<template>
    <div class="info info-box type2">
        <div class="info-box__item info-box__agent">
            <div class="info-box__agent-inner">
                
                <h3 class="info-box__tit" v-if="$store.state.hospStore.hostNm !== '혈액암병원'">
                    첫 진료 예약 / <span class="font-main">알림톡 서비스</span>
                </h3>
                <h3 class="info-box__tit" v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                    첫 방문 환자 예약
                </h3>

                <p class="info-box__desc">전문 상담사가 첫 진료 환자 예약을 도와드립니다. <br>
                    상담시간 : 평일 09: 00 - 17:00(토요일, 공휴일 제외)</p>

                <p class="info-box__desc red" v-if="$store.state.hospStore.hostNm !== '혈액암병원'">
                    *알림톡 서비스는 24시간 진료예약, 변경/취소, 증명서 발급이 가능합니다.
                
                </p>
                <div class="info-box__input type2">
                    <label><input type="text" class="input" placeholder="성함" v-model="name"></label>
                    <label><input type="text" class="input" placeholder="휴대전화번호" v-model="tel" @input="this.$commonUtils.numberOnly"></label>
                </div>
            </div>
            <div class="botton-wrap">
                <a href="javascript:;" class="main-button c-sub" @click="showPopup('firstVisible')">예약신청</a>
                <a href="javascript:;" class="main-button yellow" @click="showPopup('alarmVisible')" v-if="$store.state.hospStore.hostNm !== '혈액암병원'">알림톡 서비스</a>
            </div>
        </div>

        <div class="info-box__item info-box__alon">
            <div class="info-box__alon-inner">
                <div class="info-box__alon-text">
                    <h3 class="info-box__tit">온라인 예약</h3>
                    <p class="info-box__desc">온라인으로 쉽고 빠르게 예약 을 하실 수 있습니다.</p>
                </div>
                <div class="info-box__alon-icon">
                    <img src="/resource/icon/guide-icon.png" alt="" v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'">
                    <img src="/resource/icon/guide-icon-brain.png" alt="" v-if="$store.state.hospStore.hostNm === '뇌혈관병원'">
                    <img src="/resource/icon/guide-icon-mom.png" alt="" v-if="$store.state.hospStore.hostNm === '엄마아기병원'">
                    <img src="/resource/icon/guide-icon-blood.svg" alt="" v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                </div>
            </div>
            <div class="botton-wrap">
                <a href="javascript:;" class="main-button c-main" @click="goReservation">온라인예약 바로가기</a>
            </div>
        </div>
    </div>


    <div class="info" v-if="$store.state.hospStore.hostNm !== '혈액암병원'">
        <h3 class="bullet01">외래 접수 방법 및 시간 안내</h3>
        <p class="depth">이대서울병원 외래진료 예약방법은 “인터넷“, “카카오 알림톡/챗봇“, “모바일”, “전화예약“, “방문예약”등으로 이용자의 편의에 따라 선택하여 예약할 수 있습니다.</p>
        <div class="table mt20 scroll">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width:27.5%;">
                        <col style="width:55%;">
                        <col style="width:27.5%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>예약방법</th>
                            <th>절차</th>
                            <th>예약가능시간</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td> 인터넷 </td>
                            <td><router-link to="/kr/reserve/reserve" class="link">온라인예약 바로가기</router-link></td>
                            <td>24시간</td>
                        </tr>
                        <tr>
                            <td> 카카오 알림톡/챗봇 </td>
                            <td>카카오 알림톡과 챗봇을 통해 진료예약(신환,초진,재진)이 항상 가능합니다.</td>
                            <td>24시간</td>
                        </tr>
                        <tr>
                            <td> 모바일 </td>
                            <td> 모바일앱을 통해서도 재진 예약 접수가 가능합니다. </td>
                            <td>24시간</td>
                        </tr>
                        <tr>
                            <td> 전화예약 </td>
                            <td> 해피콜센터(1522-7000)로 예약을 하시면 됩니다. </td>
                            <td>
                                08:00 ~ 18:00(평일)<br>
                                08:30 ~ 12:30(토요일)
                            </td>
                        </tr>
                        <tr>
                            <td> 방문예약 </td>
                            <td> 건강보험증, 요양급여의뢰서를 지참하고 직접 본원을 방문하여 예약을 합니다. </td>
                            <td>08:00~16:45 (평일) <br>
                                08:30~11:30 (토요일)</td>
                        </tr>
                    </tbody>
                </table>
                <p class="mt20">※ 의료급여(보호)환자는 모든 진료과에 대해 요양급여의뢰서를 제출하시면 됩니다.</p>
                <p class="mt20">※ 1,2차 의료기관에서 요양급여의뢰서(진료의뢰서)를 발급 받으신 신환, 초진 환자분은 진료협력센터에서 예약 가능합니다. 진료협력센터 02-6986-5555 (평일 09:00~17:00)</p>
            </div>
        </div>
    </div>

    <div class="info" v-if="$store.state.hospStore.hostNm !== '혈액암병원'">
        <div class="info">
            <h3 class="bullet01">진료(예약)일 변경 및 취소</h3>
            <p class="depth">외래 진료를 예약하신 분이 부득이한 사정 등으로 당일 진료를 받으실 수 없을 경우는 1일전까지 연락하여 진료일자를 변경하거나 취소 하셔야 합니다.</p>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>구분</th>
                                <th>방법</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> 진료 예약, 취소 및 변경 </td>
                                <td>해피콜센터 (1522-7000) <br>
                                    병원 홈페이지 <br>
                                    카카오 알림톡/챗봇 <br>
                                    모바일</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


    <div class="info" v-if="$store.state.hospStore.hostNm === '혈액암병원'">
        <h3 class="bullet01">외래 접수 방법 및 시간 안내</h3>
        <p class="depth">이대목동병원의 외래진료 예약제도는 “방문예약”, “재진예약”, “유선 및 통신예약” (전화, 인터넷, 모바일)등 이용자의 편의에 따라 선택하여 진찰을 받을 수 있는 제도 입니다.</p>
        <div class="table mt20 scroll">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width:27.5%;">
                        <col style="width:55%;">
                        <col style="width:27.5%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>예약방법</th>
                            <th>절차</th>
                            <th>예약가능시간</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>방문 예약</td>
                            <td>건강보험증, 요양급여의뢰서를 지참하고 직접 본원 방문 후 예약</td>
                            <td>
                                08:00 ~ 17:00(평일) <br>
                                08:30 ~ 11:30(토요일)
                            </td>
                        </tr>
                        <tr>
                            <td>전화 예약</td>
                            <td>해피콜센터(1600-5000)으로 전화 예약</td>
                            <td>
                                08:00 ~ 18:00(평일) <br>
                                08:30 ~ 12:30(토요일)
                            </td>
                        </tr>
                        <tr>
                            <td> 인터넷 </td>
                            <td><router-link to="/kr/reserve/reserve" class="link">외래진료예약 바로가기</router-link></td>
                            <td>24시간</td>
                        </tr>
                        <tr>
                            <td>모바일</td>
                            <td>모바일 앱으로 예약 접수</td>
                            <td>24시간</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <p class="mt20">
            ※ 이대목동병원은 의료전달체계가 필요한 종합전문요양기관(3차 진료기관)으로 1차 또는 2차(의원, 병원) 진료기관에서 발급한 요양급여의뢰서(진료의뢰서)나 건강검진, 건강진단결과서를
            제출해야 건강보험 적용을 받을 수 있습니다. 단, 의료급여환자는 모든 진료과에 대해 2차진료기관(병원급)에서 발급한 의료급여의뢰서를 제출해야 의료급여 적용을 받을 수 있습니다.
            <br>
            ※ 1,2차 의료기관에서 요양급여의뢰서(진료의뢰서)를 발급받으신 신환, 초진 환자분은 진료협력센터(02-2650-5200, 평일 08:30~17:30)에서 예약 가능합니다.​
            <br>
            <!-- ※ 첫방문 환자는 1층 첫진료 라운지에서 접수가 가능합니다. -->
        </p>
    </div>

    <div class="info" v-if="$store.state.hospStore.hostNm === '혈액암병원'">
        <div class="info">
            <h3 class="bullet01">진료(예약)일 변경 및 취소</h3>
            <p class="depth">외래 진료를 예약하신 분이 부득이한 사정 등으로 당일 진료를 받으실 수 없을 경우는 1일전까지 연락하여 진료일자를 변경하거나 취소 하셔야 합니다.</p>
            <div class="table mt20 scroll">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>구분</th>
                                <th>방법</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> 진료 예약, 취소 및 변경 </td>
                                <td>
                                    해피콜센터 <br class="pc-none">(1666-5000) <br>
                                    병원 홈페이지
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <kr_FirstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup"/>
    <kr_AlarmTalkPopup :popupVisible="alarmVisible" :name="name" :tel="tel" @hide-popup="hidePopup"/>
</template>

<script>
export default {
    data() {
        return {
            firstVisible: false,
            alarmVisible: false,
            name: '',
            tel: '',
        }
    },
    mounted() {
    },
    methods: {
        goReservation(){
            this.$store.state.patInfoStore = {}
            this.$router.push('/kr/reserve/reservation')
        },
        showPopup(param){
            if(!this.name || !this.tel){
                alert('성함과 휴대전화번호를 입력해주세요.')
                return
            }
            this[param] = true
        },
        hidePopup(param){
            this[param] = false
            this.name = ''
            this.tel = ''
        }
    },
}
</script>